module.exports = __webpack_public_path__ + "static/media/Health_And_Safety_Phone-01.fc2938cb.png";